import { render, staticRenderFns } from "./extra-style-ranking.vue?vue&type=template&id=8a24847a&scoped=true&"
import script from "./extra-style-ranking.vue?vue&type=script&lang=js&"
export * from "./extra-style-ranking.vue?vue&type=script&lang=js&"
import style0 from "./extra-style-ranking.vue?vue&type=style&index=0&id=8a24847a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a24847a",
  null
  
)

export default component.exports